<script>
import bem from '@/utils/bem';
import { mapActions, mapState } from 'vuex';
import columns from '@/pages/settings/messageTemplates/columns';
import {
  CREATE,
  SAVE,
  CLOSE,
  MESSAGES_TITLE,
  MESSAGES_TEXT,
  LINK_LIST,
  CREATE_NEW,
} from './constants';

const b = bem('messages-templates');
export default {
  components: {
  },
  data() {
    return {
      isShowEditor: false,
      messagesData: {},
      textPopup: null,
      popupTextValue: '',
      popupSelectorValue: null,
      columns: columns([]),

      CREATE,
      SAVE,
      CLOSE,
      MESSAGES_TITLE,
      MESSAGES_TEXT,
      LINK_LIST,
      CREATE_NEW,
    };
  },
  methods: {
    ...mapActions({
      getMessagesTemplatesAction: 'templates/getMessagesTemplates',
      addMessagesTemplateAction: 'templates/addMessagesTemplate',
      editMessagesTemplateAction: 'templates/editMessagesTemplate',
      deleteMessagesTemplateAction: 'templates/deleteMessagesTemplate',
      getPmUsersAction: 'users/getPmUsers',
    }),
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    getUserList(list) {
      return (list || []).map(({
        id,
        firstName,
        lastName,
        email,
      }) => ({
        value: id,
        label: `${firstName} ${lastName} (${email})`,
        text: `${firstName} ${lastName} (${email})`,
      }));
    },
    onEdit(item) {
      this.isShowEditor = !this.isShowEditor;
      const {
        user,
        ...data
      } = item;
      this.messagesData = { ...data };
    },
    onClickSave() {
      const {
        id = null,
        ...payload
      } = this.messagesData;

      if (id) {
        this.editMessagesTemplateAction(
          { id, body: payload, params: {} },
        );
      } else {
        this.addMessagesTemplateAction(
          { body: payload, params: {} },
        );
      }

      this.isShowEditor = false;
      this.messagesData = false;
    },
    clearEditStatus() {
      this.isShowEditor = false;
      this.messagesData = false;
    },
    changeMessage({ key, value }) {
      this.messagesData = {
        ...this.messagesData,
        [key]: value,
      };
    },
    onChangeText(e) {
      const {
        target: {
          value,
        },
      } = e;
      if (value.length >= 2) {
        const subString = value.substr(value.length - 2);
        if (subString === '[[') {
          e.target.blur();
          this.textPopup = 'link';
        }
      }
      this.changeMessage({
        key: 'message',
        value,
      });
    },
    closeVariable() {
      this.textPopup = null;
      this.popupSelectorValue = null;
      this.popupTextValue = null;
      this.changeMessage({
        key: 'message',
        value: ((this.messagesData || {}).message || '').slice(0, -2),
      });
    },
    saveVariable() {
      const {
        message,
      } = this.messagesData || {};
      this.changeMessage({
        key: 'message',
        value: `${message}${this.popupTextValue}|${this.popupSelectorValue.value}]]`,
      });
      this.textPopup = null;
      this.popupSelectorValue = null;
      this.popupTextValue = null;
    },
    onDelete(id) {
      this.deleteMessagesTemplateAction({ id, params: {} });
    },
    setPopupSelectorValue(list, value) {
      this.popupSelectorValue = list.find((item) => item.value === value);
    },
    setShowEditor(value) {
      this.isShowEditor = value;
    },
  },
  mounted() {
    this.getPmUsersAction({
      limit: 99999,
      offset: 0,
    });
    this.getMessagesTemplatesAction();
  },
  computed: {
    ...mapState({
      messagesTemplates: (state) => state.templates.messagesTemplates,
      isLoading: (state) => state.templates.isLoading,
      pmUsers: (state) => state.users.pmUsers,
    }),
  },
  watch: {
    isFilterChanged() {
      this.getSmsTemplatesAction(this.getRequestBody());
    },
    pmUsers(newValue, oldValue) {
      if (!(oldValue || []).length && (newValue || []).length) {
        this.columns = columns(this.getUserList(newValue));
      }
    },
  },
};
</script>

<template>
  <div :class="b()">
    <div v-if="!isShowEditor" :class="b('messages-top-block')">
      <a-button
        type="primary"
        @click="() => { setShowEditor(true) }"
      >
        {{CREATE_NEW}}
      </a-button>
    </div>
    <a-table
      :class="b('table', { hide: isShowEditor })"
      :columns="columns"
      :dataSource="messagesTemplates"
      :pagination="false"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.dataIndex === 'actions'">
          <div :class="b('action-buttons')">
            <a-button
              type="primary"
              html-type="button"
              @click="() => {onEdit(record)}"
            >
              Edit
            </a-button>
            <a-button
              type="primary"
              html-type="button"
              danger
              @click="() => {onDelete(record.id)}"
            >
              Delete
            </a-button>
          </div>
        </template>
      </template>
    </a-table>
    <div v-if="isShowEditor" :class="b('messages-editor')">
      <div :class="b('messages-top-block')">
        <a-button
          type="primary"
          html-type="button"
          @click="onClickSave()"
          :disabled="!messagesData.message || !messagesData.title"
        >
          {{messagesData.id ? SAVE : CREATE}}
        </a-button>
        <a-button
          html-type="button"
          @click="clearEditStatus()"
        >
          {{CLOSE}}
        </a-button>
      </div>
      <div :class="b('title')">{{MESSAGES_TITLE}}</div>
      <a-input
        type="text"
        v-model:value="messagesData.title"
      />
      <div :class="b('title')">{{MESSAGES_TEXT}}</div>
      <a-input
        type="text"
        :value="messagesData.message"
        @change="(e) => { onChangeText(e); }"
      />
      <div :class="b('title')">{{MESSAGES_TEXT}}</div>
      <a-select
        style="width: 180px"
        :value="getUserList(pmUsers).find(item=> item.value === messagesData.userId)"
        :options="getUserList(pmUsers)"
        @change="(e) => {
          changeMessage({
            key: 'userId',
            value: e || '',
          });
        }"
      />
      <div v-if="textPopup" :class="b('add-variable')">
        <div :class="b('add-variable-block')">
          <div :class="b('style-item')">
            <div :class="b('title')">Link text</div>
            <a-input
              type="text"
              v-model:value="popupTextValue"
            />
          </div>
          <div :class="b('style-item')">
            <div :class="b('title')">Link</div>
            <a-select
              style="width: 180px"
              :value="popupSelectorValue"
              :options="LINK_LIST"
              @change="(e) => {
                setPopupSelectorValue(LINK_LIST, e);
              }"
            />
          </div>
          <div :class="b('add-variable-buttons')">
            <a-button
              html-type="button"
              @click="closeVariable"
            >
              Close
            </a-button>
            <a-button
              type="primary"
              html-type="button"
              @click="saveVariable"
              :disabled="popupSelectorValue"
            >
              Save
            </a-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style src="./style.scss" scoped lang="scss"></style>
